<template>
    <div class="app-container pageoptions">
        <el-row class="toprow is-text-align-right">
            <el-tooltip content="Nouvelle option">
                <el-link
                    type="success"
                    size="small"
                    icon="el-icon-plus"
                    @click="createOption()"
                />
            </el-tooltip>
        </el-row>
        <el-table
            v-loading="loading"
            :data="options"
            border
            fit
            highlight-current-row
            style="width: 100%"
        >
            <!--
            <el-table-column align="left" label="Slug" width="150" prop="slug">
                <template slot-scope="scope">
                    <span>{{ scope.row.slug }}</span>
                </template>
            </el-table-column>
            -->
            <el-table-column align="left" label="Étape" width="100" prop="slug">
                <template slot-scope="scope">
                    <span>{{ scope.row.etape }}</span>
                </template>
            </el-table-column>
            <el-table-column
                align="left"
                label="Desc."
                width="250"
                prop="description"
            >
                <template slot-scope="scope">
                    <span>{{ scope.row.description }}</span>
                </template>
            </el-table-column>
            <el-table-column align="left" label="Val." prop="data">
                <template slot-scope="scope">
                    <span v-html="$options.filters.shorter(scope.row.data)" />
                </template>
            </el-table-column>
            <el-table-column align="right" prop="edit" width="50">
                <template slot-scope="scope">
                    <el-tooltip content="Données option">
                        <el-link
                            type="success"
                            size="small"
                            icon="el-icon-edit"
                            @click="editOption(scope.row)"
                        />
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>
        <theoption
            :isvisible="dialogOptionVisible"
            :option="activeOption"
            :parent="this"
        />
    </div>
</template>

<script>
import Resource from "@/api/resource";
const optionResource = new Resource("options");
import theoption from "@/components/Option";

export default {
    name: "Options",
    components: {
        theoption
    },
    data() {
        return {
            loading: false,
            options: null,
            dialogOptionVisible: false,
            activeOption: {}
        };
    },
    created() {
        console.log("getOptions");
        this.getOptions();
    },
    watch: {},
    methods: {
        createOption() {
            this.activeOption = {
                id: null,
                slug: "",
                description: "",
                data: ""
            };
            this.dialogOptionVisible = true;
        },
        editOption(option) {
            console.log("editOption " + option.id);
            this.activeOption = option;
            this.dialogOptionVisible = true;
        },
        async getOptions() {
            console.log("getOptions");
            this.loading = true;
            const { data } = await optionResource.list({});
            this.options = data;
            this.loading = false;
            console.log(this.options);
        },
        callbackOption(reload, option) {
            if (reload) {
                this.getOptions();
            }
            if (option) {
                Object.assign(this.activeOption, option);
            }
        }
    }
};
</script>
